<template>
    <div>
        <div v-show="!addToggle" class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-container">
                    <div class="panel-content">
                        <div v-if="!addToggle" class="text-right mt-3 mb-1">
                            <button class="btn btn-sm btn-outline-primary mr-3" type="button" :title="shopItems.length == 0 ? $t('button_link.add') : $t('button_link.edit')" @click="showTukangShopForm">
                                <span class="fal" :class="shopItems.length == 0 ? 'fa-plus' : 'fa-cog'"></span>
                            </button>
                            <!-- <button class="btn btn-sm btn-outline-primary" type="button" :title="$t('button_link.delete')" @click="showDeleteTukangShop">
                                <span class="fal fa-trash" ></span>
                            </button> -->
                        </div>
                        <div v-if="!addToggle">
                            <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                                <b-spinner label="Loading..."></b-spinner>
                            </div>
                            <div class="panel-tag mt-3" v-if="!isSpinnerShow && shopItems.length == 0">
                                {{$t('table.no_records')}} {{$t('message.info.add_tukang', {'item': $t('header.tukang_shop')})}}
                            </div>
                            <div v-if="!isSpinnerShow && shopItems.length != 0">
                                <h5 class="text-primary fw-500 text-center alert-primary p-3">{{$t('header.tukang_shop')}}</h5>
                                <div v-for="item in shopItems" :key="item.TkShopID" class="row shop-row">
                                    <div class="col-sm-12 col-md-4 d-flex align-items-center">
                                        <div>
                                            <h1 class="shop-title mb-3">{{item.TkCompanyName}}</h1>
                                            <p class="text-secondary fw-300 fs-md mb-4">
                                                <i class="fal fa-quote-left text-primary mr-2"></i>
                                                {{item.TkCompanyDetails}}
                                                <i class="fal fa-quote-right text-primary ml-2"></i>
                                            </p>
                                            <p class="text-secondary fw-300 fs-sm mb-1">
                                                <i class="fal fa-map-marker-alt text-primary fs-xl"></i>
                                                {{item.TkCompanyLocation}}, {{getCity(item.TkCompanyCityID)}}
                                            </p>
                                            <p class="text-muted fw-300 fs-sm">
                                                <i class="fal fa-phone-alt text-primary fs-xl"></i>
                                                {{item.TkCompanyMobile}}
                                            </p>
                                        </div>
                                        
                                    </div>
                                    <div class="col-sm-12 col-md-8 pt-3 pb-3">
                                        <lingallery v-if="item.TkCompanyImage.length != 0"
                                            :items="item.TkCompanyImage"
                                            :showThumbnails="true"
                                            :responsive="true"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-show="addToggle" class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2>{{shopItems.length == 0 ? $t('button_link.add') : $t('button_link.edit')}} {{$t('header.tukang_shop')}}</h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <tukangShopForm ref="tukangShopForm" @renderTukangShop="renderTukangShop" @returnShopList="returnShopList"></tukangShopForm>
                    </div>
                </div>
            </div>
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="deleteTukangShop"></deleteModal>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal'
import TukangShopForm from './Tukang_Shop_Form'
import Lingallery from 'lingallery';
import {handleSessionExpired} from '@/assets/js/dashboard/dashboard.js'
export default {
    name: "tukangShop",
    components:{
        TukangShopForm,
        Lingallery,
        DeleteModal
    },
    props:{
        cityList: {type: Array}
    },
    data(){
        return{
            shopItems: [],
            isSpinnerShow: false,
            addToggle: false, sTitle: "",
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.$refs.deleteModal.toggleModal = false
                this.getTukangShop()
            }
            this.$parent.$parent.isModalShow = false
        },
        getCity(id){
            var city = ""
            for(var i=0; i<this.cityList.length; i++){
                if(parseInt(id) == this.cityList[i].cityID){
                    city = this.cityList[i].city
                    break
                }
            }
            return city
        },
        showTukangShopForm(){
            this.addToggle = true
            var status = this.shopItems.length == 0 ? "add" : "update"

            if(status == "update"){
                this.$refs.tukangShopForm.editTukangShopForm(this.shopItems[0])
            }
        },
        async getTukangShop(){
            this.shopItems = []
            let $vm = this;
            var result = []
            this.isSpinnerShow = true
            await $vm.$axios({
                method: 'get', 
                url: $vm.$api.TUKANG_SHOP,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then(function(response) {
                result = response.data.result
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
            var items = [];
            for(var i=0; i<result.length; i++){
                var image = []
                for(var j=1; j<=6; j++){
                    var key = "TkCompanyImage" + j
                    if(result[i][key] != ""){
                        image.push({
                            index: j,
                            id: key,
                            src: result[i][key],
                            thumbnail: result[i][key],
                        })
                    }
                }
                items.push({
                    shopID: result[i].shopID,
                    TkShopID: result[i].TkShopID,
                    TkCompanyName: result[i].TkCompanyName,
                    TkCompanyMobile: result[i].TkCompanyMobile,
                    TkCompanyLocation: result[i].TkCompanyLocation,
                    TkCompanyDetails: result[i].TkCompanyDetails,
                    TkCompanyCityID: result[i].TkCompanyCityID,
                    TkCompanyImage: image,
                })
            }
            this.isSpinnerShow = false
            this.shopItems = items
            if(items.length != 0){
                this.sTitle = items[0].TkCompanyName
            } 
        },
        returnShopList(){
            this.addToggle = false
            this.getTukangShop()
        },
        showDeleteTukangShop(){
            var title = this.$i18n.t('button_link.delete') + this.$i18n.t('header.tukang_shop')
            var message = this.$i18n.t('message.confirmation.question', {'action': this.$i18n.t('message.confirmation.action.delete'), 'item': this.shopItems[0].TkCompanyName})
            this.$refs.deleteModal.showModal(title, message)
        },
        deleteTukangShop(){
            let $vm = this
            const url =  this.$api.TUKANG_SHOP + this.$api.DELETE;
            
            this.$axios({
                method: 'post', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then((response) => {
                if(response.status == 200){
                    var message = $vm.$i18n.t('header.tukang_shop') + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.delete')})
                    $vm.$parent.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var error = err.response.data.error;
                if(error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();   
                }
            })
        },
        async renderTukangShop(){
            await this.getTukangShop()
            this.$refs.tukangShopForm.editTukangShopForm(this.shopItems[0])
        },
    },
    async mounted(){
        let $vm = this
        $vm.getTukangShop();
    },
}
</script>
<style scoped>
.shop-title{
    font-family: Snell Roundhand, cursive;
    color: #6e4e9e;
    font-weight: bold;   
}
.shop-row{
    background: #FCF9FF;
    margin-left: .05em;
    margin-right: .05em;
}
.show{
    display: block;
}
</style>